// initialState 
// Storeの初期状態を定義する
import { FirebaseTimestamp } from "../../firebase";
import {Product} from "../products/types";
import {Timestamp} from "firebase/firestore";
import {UserState} from "../users/types";
import {AsyncStatus} from "../asyncState";

type InitialStateType = {
  products: {
    list: Product[],
    received_date: Timestamp,
    status: AsyncStatus
  },
  users: UserState
}

const initialState: InitialStateType = {
  // カテゴリに分けて、オブジェクトで記述
  products: {
    list: [],
    received_date: FirebaseTimestamp.fromDate(new Date(),), //ProductListで今日が選択されていると日付を選択してくださいと出すようにしている
    status: 'idle',
  },
  users: {
    address: '',
    birthdayYear: '',
    birthdayMonth: '',
    cart: [],
    email: '',
    // favorite: [], //
    firstNameKana: '',
    gender: '',
    lastNameKana: '',
    isSignedIn: false,
    orders: [],
    phone: '',
    role: '',
    uid: '',
  }
};

export default initialState